// TaxCalculator.js

import React, { useState } from 'react';
import './TaxCalculator.css';
import {
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from "react-i18next";

const TaxCalculator = () => {
    const [open, setOpen] = useState(false);
    const [price, setPrice] = useState('');
    const [tax, setTax] = useState(null);
    const [error, setError] = useState('');
    const {t} = useTranslation();
    const handleCalculate = () => {
        const priceValue = parseFloat(price);
        if (isNaN(priceValue) || priceValue < 0) {
            setError('გთხოვთ, შეიყვანეთ  დადებითი რიცხვი.');
            setTax(null);
            return;
        }
        if (priceValue > 100000000000000) {
            setError('ფასი არ უნდა აღემატებოდეს 100,000,000,000,000-ს.');
            setTax(null);
            return;
        }
        setError('');
        const calculatedTax = calculateTax(priceValue);
        setTax(calculatedTax.toFixed(2));
    };

    const calculateTax = (price) => {
        let tax;
        if (price < 500000) {
            tax = 1000 + 0.005 * price;
        } else if (price < 1000000) {
            tax = 8000;
        } else if (price < 3000000) {
            tax = 14000;
        } else if (price < 5000000) {
            tax = 19000;
        } else if (price < 10000000) {
            tax = 24000;
        } else {
            tax = 24000 + 0.0001 * price;
        }
        return tax;
    };

    const handleClose = () => {
        setOpen(false);
        setPrice('');
        setTax(null);
        setError('');
    };

    return (
        <>
            <div className="qa-link" onClick={() => setOpen(true)}>
                {t("გაიგე მეტი")}
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                className="tax-calculator-dialog"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle className="tax-calculator-title">
                    <Typography variant="h6">{t('მოსაკრებელის კალკულატორი')}</Typography>
                    <IconButton
                        aria-label="დახურვა"
                        onClick={handleClose}
                        className="close-button"
                        size="large"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent className="tax-calculator-content">
                    <TextField
                        label={t("შეიყვანეთ პროექტის ღირებულება (ლარში)")}
                        type="number"
                        variant="outlined"
                        fullWidth
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        className="tax-calculator-input"
                        InputProps={{ inputProps: { min: 0, max: 100000000000 } }}
                        error={!!error}
                        helperText={error}
                    />
                    {tax !== null && (
                        <div className="tax-calculator-result">
                            <Typography variant="h6">
                                გადასახდელი თანხა: <strong>{tax}</strong> ლარი
                            </Typography>
                        </div>
                    )}
                </DialogContent>
                <Divider />
                <DialogActions className="tax-calculator-actions">

                    <Button disabled={price === '' || price < 1} onClick={handleCalculate} variant="contained" color="primary">

                        {t("გამოთვლა")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TaxCalculator;
